import { BLACK_900, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
import { getThemeStyles } from '../../SchedulingWidgetUtils';
export var getSchedulingCarouselItemStyles = (isLargeScreen, isSelected, theme) => {
  var spacing = tokens.spacing;
  var paddingVertical = isLargeScreen ? spacing.SPACING_12 : spacing.SPACING_8;
  var minWidth = isLargeScreen ? 62 : 52;
  var minHeight = isLargeScreen ? 70 : 54;
  var themeStyles = getThemeStyles(theme);
  return StyleSheet.create({
    carouselCardContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: isSelected ? BLACK_900 : themeStyles === null || themeStyles === void 0 ? void 0 : themeStyles.backgroundColor,
      borderRadius: spacing.SPACING_12,
      borderWidth: 1,
      borderColor: themeStyles.borderColor,
      paddingVertical,
      minWidth,
      minHeight
    },
    carouselCardContainerSpacing: {
      marginRight: spacing.SPACING_12
    }
  });
};